<div class="wrapper">
  <div class="button">
    <app-google-signin-wrapper />
    <br />
    <app-telegram-sign-button />
  </div>
  <div class="warn">
    <p>
      {{ 'SIGN.AAS' | translate
      }}<a href="https://lotodobicho.com/doc?chapter=tc&lang=pt">{{ 'SIGN.TOS' | translate }}</a>
    </p>
  </div>
</div>
